import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { PropTypes } from 'prop-types';
import { setUserData } from '../redux/actions/UserActions';
import jwtAuthService from '../services/jwtAuthService';
import localStorageService from '../services/localStorageService';
import firebaseAuthService from '../services/firebase/firebaseAuthService';
import { identifyUser } from '../services/chameleonService';

class Auth extends Component {
  state = {};

  constructor(props) {
    super(props);

    this.props.setUserData(localStorageService.getItem('auth_user'));
    // this.checkJwtAuth();
    // this.checkFirebaseAuth();
  }

  checkJwtAuth = () => {
    jwtAuthService.loginWithToken().then((user) => {
      this.props.setUserData(user);
    });
  };

  componentDidMount() {
    const user = localStorageService.getItem('auth_user')
    if (user && user.id) {
      //console.log("chameleon:" + JSON.stringify(user));

      try {
        identifyUser(user);
      } catch (error) {
        console.log('chameleon:' + JSON.stringify(error));
      }
      
    }
  }

  checkJwtAuth = () => {
    jwtAuthService.loginWithToken().then((user) => {
      if (user) {
        this.props.setUserData(user);
      }
    });
  };

  checkFirebaseAuth = () => {
    firebaseAuthService.checkAuthStatus((user) => {
      if (user) {
        console.log(user.uid);
        console.log(user.email);
        console.log(user.emailVerified);
      } else {
        console.log('not logged in');
      }
    });
  };

  render() {
    const { children } = this.props;
    return <Fragment>{children}</Fragment>;
  }
}

const mapStateToProps = (state) => ({
  setUserData: PropTypes.func.isRequired,
  login: state.login,
});

export default connect(mapStateToProps, { setUserData })(Auth);
